class ShopTheLookModal extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.shop-the-look-modal__close-button');
    this.overlay = this.querySelector('.shop-the-look-modal__overlay');
    this.content = this.querySelector('.shop-the-look-modal__content');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        console.log('Close button clicked');
        this.close();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        console.log('Overlay clicked');
        this.close();
      });
    }

    // Prevent clicks inside modal content from closing the modal
    if (this.content) {
      this.content.addEventListener('click', (e) => e.stopPropagation());
    }
  }

  close() {
    console.log('Closing modal');
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

class BundleGridItem extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.bundle-grid-item__button');

    if (this.button) {
      this.button.addEventListener('click', () => {
        const modalId = `#ShopTheLookModal-${this.button.dataset.bundleId}`;
        const modal = document.querySelector(modalId);

        if (modal) {
          modal.setAttribute('open', '');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
    }
  }
}

// Only define the custom elements if they haven't been defined yet
if (!customElements.get('shop-the-look-modal')) {
  customElements.define('shop-the-look-modal', ShopTheLookModal);
}

if (!customElements.get('bundle-grid-item')) {
  customElements.define('bundle-grid-item', BundleGridItem);
}
